import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { PaginatedResponse } from 'src/app/shared/interfaces'
import { buildHttpParams } from 'src/app/shared/query-utils'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

import { BookingItem } from './booking-item'
import { BookingItemSerializer } from './booking-item.serializer'
import { SubscriberService } from '../../subscription/subscriber/subscriber.service'

@Injectable()
export class BookingItemService extends ResourceService<BookingItem> {
  // TODO create some resource service to extend that works for services like this
  constructor(
    public http: HttpClient,
    public serializer: BookingItemSerializer,
    private subscriberService: SubscriberService
  ) {
    super(http, `${environment.backendApiUrl}/booking-items`, serializer)
  }

  public getManyByBookingId(
    bookingId: number,
    params?: RequestQueryBuilder
  ): Observable<BookingItem[]> {
    return this.http
      .get<PaginatedResponse>(
        `${environment.backendApiUrl}/bookings/${bookingId}/booking-items`,
        {
          params: buildHttpParams(params)
        }
      )
      .pipe(
        map((reponse) =>
          reponse.data.map(
            (data: any) => this.serializer.fromJson(data) as BookingItem
          )
        )
      )
  }

  public getOneByBookingId(
    bookingId: number,
    bookingLine: number,
    params?: RequestQueryBuilder
  ): Observable<BookingItem> {
    return this.http.get<BookingItem>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-items/${bookingLine}`,
      {
        params: buildHttpParams(params)
      }
    )
  }

  public updateOneByBookingId(
    bookingId: number,
    bookingLine: number,
    params: Partial<BookingItem>
  ): Observable<BookingItem> {
    return this.http.patch<BookingItem>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-items/${bookingLine}`,
      {
        ...params
      }
    )
  }

  public deleteOneByBookingId(
    bookingId: number,
    bookingLine: number
  ): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-items/${bookingLine}`
    )
  }

  public createOneByBookingId(
    bookingId: number,
    params: Partial<BookingItem>
  ): Observable<BookingItem> {
    return this.http.post<BookingItem>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-items`,
      {
        ...params
      }
    )
  }
}
